export const LANGUAGE_NAMESPACE = {
  DEFAULT: 'DEFAULT',
}
